import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const submitDatum = (formData) => API.post('/datum', formData)
export const submitDatum_update = (formData, sessionId) => API.post('/datum/update', {...formData, sessionId})
export const submitDatum_savedraft = (formData) => API.post('/datum/savedraft', formData)
export const submitDatum_delete = (formData) => API.post('/datum/delete', formData)
// export const submitDBupdate = () => API.get('/datum/dbupdate')